import {Link} from "react-router-dom";

function Nav() {
    return (
        <nav className="nav">
            <ul>
                <li><Link to='/'>Загальні компетентності</Link></li>
                <li>
                    <Link to='/about'> Перелік трудових функцій, професійних компетентностей (за трудовою дією
                        або групою трудових дій, що входять до них), умовні позначення трудових функцій</Link>
                </li>
            </ul>
            <h5>Організація здорового, безпечного, розвивального, інклюзивного освітнього середовища</h5>
            <ul>
                <li>
                    <Link to='/a1'> A1 Здоров’язбережувальна</Link>
                </li>
                <li>
                    <Link to='/a2'>A2 Проектувальна</Link>
                </li>
            </ul>
            <h5>Управління закладом дошкільної освіти</h5>
            <ul>
                <li>
                    <Link to='/b1'>Б1 Операційне управління закладом дошкільної освіти</Link>
                </li>
                <li>
                    <Link to='/b2'>Б2 Організаційно-методична</Link>
                </li>
                <li>
                    <Link to='/b3'>Б3 Комунікативна</Link>
                </li>
            </ul>
            <h5>Безперервний особистісний та професійний розвиток</h5>
            <ul>
                <li>
                  <Link to='/v1'>  В1 Здатність до навчання впродовж життя</Link>
                </li>
                <li>
                   <Link to='/v2'> В2 Інформаційно-комунікаційна</Link>
                </li>
            </ul>
            <h5>Лідерство і партнерська взаємодія</h5>
            <ul>
                <li>
                   <Link to='/h1'> Г1 Лідерська</Link>
                </li>
                <li>
                   <Link to='/h2'> Г2 Емоційно-етична</Link>
                </li>
            </ul>
            <h5>Стратегічний розвиток закладу дошкільної освіти</h5>
            <ul>
                <li>
                    <Link to='/g1'>Ґ1 Стратегічне управління та розвиток закладу дошкільної освіти</Link>
                </li>
                <li>
                    <Link to='/g2'>Ґ2 Стратегічна комунікація</Link>
                </li>
                <li>
                    <Link to='/g3'> Ґ3 Нормативно-правова</Link>
                </li>
            </ul>

        </nav>
    )
}

export {Nav}